import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";


export default class DocumentationHelper {
    public static getUrl(sections: string[], hash?: string): string {
        return `${LcabApiRequest.getCabinetUrlPrefix()}/json-doc/${sections.join(',')}${hash ? '#' + hash : ''}`;
    }
}